import { render, staticRenderFns } from "./LargeLabels.vue?vue&type=template&id=5c27d13c&scoped=true"
import script from "./LargeLabels.vue?vue&type=script&lang=js"
export * from "./LargeLabels.vue?vue&type=script&lang=js"
import style0 from "./LargeLabels.vue?vue&type=style&index=0&id=5c27d13c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c27d13c",
  null
  
)

export default component.exports